export default __webpack_public_path__ + "static/media/Reigning.5630b484.jpg";